// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2E4P0","inputWrap":"CustomTip_inputWrap__22Ab_"};